import {createSvgIcon} from '../create-svg-icon';

export const TrendingDownIcon = createSvgIcon(
  <path d="m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z" />
, 'TrendingDownOutlined');
